// extracted by mini-css-extract-plugin
export var carrierTab = "_3n-0";
export var carrierTabActive = "_3n-1 _3n-0";
export var carrierTabInactive = "_3n-2 _3n-0";
export var carrierTabLabel = "_3n-3";
export var carrierTabLabelActive = "_3n-4 _3n-3";
export var carrierTabLabelInactive = "_3n-5 _3n-3";
export var carrierTabPercentage = "_3n-6";
export var carrierTabPercentageActive = "_3n-7 _3n-6";
export var carrierTabPercentageInactive = "_3n-8 _3n-6";
export var carrierTabWinnable = "_3n-9";
export var carrierTabWinnableActive = "_3n-a _3n-9";
export var carrierTabWinnableInactive = "_3n-b _3n-9";
export var comparisonContainer = "_3n-d";
export var missingRateButton = "_3n-n";
export var missingRateButtonActive = "_3n-o _3n-n";
export var missingRateButtonInactive = "_3n-p _3n-n";
export var missingRateButtonLabel = "_3n-q";
export var missingRateButtonLabelActive = "_3n-r _3n-q";
export var missingRateButtonLabelInactive = "_3n-s _3n-q";
export var sidebar = "_3n-c";
export var strategyButton = "_3n-e";
export var strategyButtonActive = "_3n-f _3n-e";
export var strategyButtonDescription = "_3n-k";
export var strategyButtonDescriptionActive = "_3n-l _3n-k";
export var strategyButtonDescriptionInactive = "_3n-m _3n-k";
export var strategyButtonInactive = "_3n-g _3n-e";
export var strategyButtonLabel = "_3n-h";
export var strategyButtonLabelActive = "_3n-i _3n-h";
export var strategyButtonLabelInactive = "_3n-j _3n-h";
export var unitToggleButton = "_3n-t";
export var unitToggleButtonActive = "_3n-u _3n-t";
export var unitToggleButtonInactive = "_3n-v _3n-t";
export var unitToggleButtonLabel = "_3n-w";
export var unitToggleButtonLabelActive = "_3n-x _3n-w";
export var unitToggleButtonLabelInactive = "_3n-y _3n-w";